import type { MutableRefObject } from 'react';

import { Gtm } from '@/domains/core/tracking/utils/Gtm';
import type { Product } from '@/domains/productDiscovery/algolia/interfaces/product';
import type { WithSponsoredProduct } from '@/domains/productDiscovery/Listings/sponsoredProducts/interfaces/product';

import type {
  GtmEvent,
  GtmEventPrProducts,
  productsImpressionTrackingPageType,
} from '../interfaces';
import type { ViewedProduct } from '../useProductsImpressionTracking';

export const sendGtmEvent = (
  viewedProducts: MutableRefObject<ViewedProduct[]>,
  pageType: productsImpressionTrackingPageType,
) => {
  const GTM_EVENT_PR_PRODUCTS: GtmEventPrProducts[] =
    viewedProducts.current.map(({ product, position }) => {
      const gtmEventPrProduct: GtmEventPrProducts = {
        list_name: undefined,
        pr_id: product.articleId,
        pr_brand_id: product.brandId,
        pr_brand_name: product.brandName,
        pr_is_pro: !!product.hasProConditions,
        pr_is_sponsored: !!(product as Product & WithSponsoredProduct)
          .isSponsored,
        pr_model_id: product.modelId,
        pr_model_name: product.title,
        pr_name: product.defaultTitle,
        pr_position: position,
        pr_price: product.prices.main,
        pr_product_id: product.productId,
        pr_seller_id: product.sellerId,
        pr_seller_name: product.sellerName,
        pr_category_name: product.categoriesL1?.[0],
        pr_category_id: product.categoriesL1Id?.[0],
        pr_variant: undefined,
      };

      return gtmEventPrProduct;
    });

  Gtm.push<GtmEvent>({
    event: 'interaction_view_item_list',
    e_category: 'ecommerce',
    e_action: 'list products display',
    e_label: undefined,
    amp_event_name: 'Display list products',
    event_trigger: pageType,
    block_clicked: undefined,
    pr_products: GTM_EVENT_PR_PRODUCTS,
  });
};
